<template>
<div class="ymda-warpper">
  <el-select v-model="base.time.timeResolution">
    <el-option v-for="(item, index) of base.time.avaliableTimeResolution" :key="index" :value="item.value" :label="item.name"></el-option>
  </el-select>
  <div class="range-select-warpper">
    <el-date-picker :type="base.time.timeResolution" v-model="base.time.start" @change="getEndTime" :picker-options="pickerOptions"
      :editable="false" :clearable="false"></el-date-picker>
  </div>
</div>
</template>

<script>
const moment = require('moment')
export default {
  name: 'YMDSelector',
  props: ['base'],
  data () {
    return {
      timeResolution: 'month',
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      }
    }
  },
  methods: {
    getEndTime () {
      this.base.time.end = moment(this.base.time.start).endOf(this.base.time.timeResolution).valueOf()
    }
  }
}
</script>

<style lang="scss" scoped>
.ymda-warpper {
  display: flex;

  .el-date-editor {
    width: 160px !important;
  }
  .el-select {
    width: 80px;
    margin-right: 10px;
  }
  .range-select-warpper {
    .el-date-editor {
      width: 120px;
      margin-right: 10px;
      margin-left: 0;
    }
  }
}
</style>
